import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  importProvidersFrom,
  provideZoneChangeDetection,
  isDevMode,
} from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { RouteReuseStrategy, provideRouter } from "@angular/router";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
import { File } from "@awesome-cordova-plugins/file/ngx";
import { FileOpener } from "@awesome-cordova-plugins/file-opener/ngx";
import { FileTransfer } from "@awesome-cordova-plugins/file-transfer/ngx";
import {
  provideIonicAngular,
  IonicRouteStrategy,
} from "@ionic/angular/standalone";
import { Drivers } from "@ionic/storage";
import { IonicStorageModule } from "@ionic/storage-angular";
import { API_BASE_URL } from "src/app/services/web-api-client";
import { NgxPermissionsModule } from "ngx-permissions";

import { routes } from "./app/app-routing.module";
import { AppComponent } from "./app/app.component";
import { QsJwtInceptorService } from "./app/services/qs-jwt-inceptor.service";
import { environment } from "./environments/environment.prod";
import { provideServiceWorker } from "@angular/service-worker";

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    { provide: API_BASE_URL, useValue: environment.apiRoot },
    { provide: HTTP_INTERCEPTORS, useClass: QsJwtInceptorService, multi: true },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      NgxPermissionsModule.forRoot(),
      IonicStorageModule.forRoot({
        name: "__mydb",
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
      })
    ),
    FileTransfer,
    AppVersion,
    File,
    FileOpener,
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
  ],
});
